const browserSessionStorage = window.sessionStorage
const browserLocalStorage = window.localStorage
const SHARED_PREFIX = 'jh_admin_session_'
const SHARED_KEYS = [
  'token',
  'user_id',
  'userName',
  'userInfo',
  'limit',
  'personInfo',
  'positionCode',
  'orgCode',
  'orgCodes',
  'role',
  'salesAuthorityId'
]

function sharedKey (key) {
  return SHARED_PREFIX + key
}

function isSharedKey (key) {
  return SHARED_KEYS.includes(key)
}

function restoreSharedItems () {
  SHARED_KEYS.forEach(key => {
    const value = browserLocalStorage.getItem(sharedKey(key))
    if (value !== null) {
      browserSessionStorage.setItem(key, value)
    }
  })
}

restoreSharedItems()

export default {
  getItem (key) {
    try {
      let value = browserSessionStorage.getItem(key)
      if (value === null && isSharedKey(key)) {
        value = browserLocalStorage.getItem(sharedKey(key))
        if (value !== null) {
          browserSessionStorage.setItem(key, value)
        }
      }
      return JSON.parse(value)
    } catch (err) {
      return null
    }
  },
  setItem (key, val) {
    const value = JSON.stringify(val)
    browserSessionStorage.setItem(key, value)
    if (isSharedKey(key)) {
      browserLocalStorage.setItem(sharedKey(key), value)
    }
  },
  removeItem (key) {
    browserSessionStorage.removeItem(key)
    if (isSharedKey(key)) {
      browserLocalStorage.removeItem(sharedKey(key))
    }
  },
  clear () {
    browserSessionStorage.clear()
    SHARED_KEYS.forEach(key => browserLocalStorage.removeItem(sharedKey(key)))
  },
  restoreSharedItems () {
    restoreSharedItems()
  }
}
